import { IModel } from 'app/model/base/annotation';
import { } from '../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedService } from '../linkedservice/linkedservice';

import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

export const webAuthTypes = {
    Anonymous: 'Anonymous'
};

@Metamodel.model({
    name: adfModelTypeMap.webTable.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.WebTable_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.WebTable_DisplayText)
    ]
})
export class WebTableLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Url
    })
    public url?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
